// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/companies/{OrgId}/branches",
  Detail: "/pyr/companies/{OrgId}/branches",
  ListShort: "/pyr/companies/{OrgId}/branches/short",
  Create: "/pyr/companies/{OrgId}/branches",
  Update: "/pyr/companies/{OrgId}/branches",
};
